/* eslint-disable */
import {FuseNavigationItem} from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: "my-profile",
        title: "My Profile",
        type: 'collapsable',
        icon: 'heroicons_outline:user-circle',
        children: [
            {
                id: "change-password",
                title: "Change Password",
                type: 'basic',
                icon: 'heroicons_outline:key',
                link: '/portal/my-profile/change-password'
            }
        ]
    },
    {
        id: "genuine-points-list",
        title: "Points",
        type: 'collapsable',
        icon: 'heroicons_outline:shield-check',
        children: [
            {
                id: "redeemedPoints-listing",
                title: "Redemption History",
                type: 'basic',
                icon: 'heroicons_outline:search',
                link: '/portal/points/redemption-history'
            }
        ]
    },
    {
        id: "lucky-spin",
        title: "Lucky Spin",
        type: 'collapsable',
        icon: 'heroicons_outline:gift',
        children: [
            {
                id: "lucky-spin-list",
                title: "Participation History",
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/portal/lucky-spin-list'
            }
        ]
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
